export enum TeamsQueryKeys {
  GET_ASKS = 'GET_ASKS',
  GET_TEAMS_LIST = 'GET_TEAMS_LIST',
  GET_TEAMS_FORM_OPTIONS = 'GET_TEAMS_FORM_OPTIONS',
  GET_TEAM = 'GET_TEAM',
}
